import React from 'react';
import { useParams } from 'react-router-dom';

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, name, isHeaderChecked, ...rest }, ref) => {
    const defaultRef = React.useRef(null);
    const resolvedRef = ref || defaultRef;
    React.useEffect(() => {
      if (typeof indeterminate === 'boolean') {
        resolvedRef.current.indeterminate = indeterminate;
      }
    }, [resolvedRef, indeterminate]);
    const { id } = useParams();
    return (
      <input
        id={name}
        name={name}
        // checked={(id?.toString()!=="" && id?.toString()!==undefined)||true?true:false}
        checked={true}
        aria-label='All orders checkbox'
        className='custom__checkbox self-center cursor-pointer'
        type='checkbox'
        ref={resolvedRef}
        {...rest}
      />
    );
  }
);

export default React.memo(IndeterminateCheckbox);
